import React, { useEffect } from 'react'
import { useState } from 'react'
import { Link } from 'react-router-dom'
import { useParams } from 'react-router-dom'

import Header from '../common/Header'
import SideMenu from '../common/SideMenu'
import Tr from './Tr'
import NewCardSettingModal from './Modal/NewCardSettingModal'

import './Oripa.css'
import ImageModal from '../common/Modal/ImageModal'

import { useTranslation } from "react-i18next";

const NewOripaSelectCard = ({moveNewOripaConfirm, moveNewOripaGeneral, packageInfo, cardNumber, setCardNumber, cardList, setCardList, update}) => {
  const { t } = useTranslation();

  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [modalImageIsOpen, setModalImageIsOpen] = useState([false, '']);


  const addCardHandler = () => {
    setCurrentCard({
      url: '',
      name: '',
      rank: "1",
      number: 1,
      rewardPoint: 0,
      id: '',
      option: "1",
      image: '',
      psa: 0,
      isPsaEnabled: "2",
    });
    openModal();
  }

  const [zipUpButton, setZipUpButton] = useState(t('new_oripa_select_card.zip'));

  const csvCardHandler = () => {
    if (window.confirm(t('new_oripa_select_card.confirm'))) {
      document.getElementById('zip').click();
    }
  }

  const templateHandler = () => {
    window.open(process.env.REACT_APP_ASSET_URL + '/static/template/template.csv');
  }

  const zipCardHandler = () => {
    setZipUpButton(t('new_oripa_select_card.uploading'));

    let xsrfToken = document.cookie.split('; ').find(row => row.startsWith(process.env.REACT_APP_XSRF_TOKEN));
    if (xsrfToken) {
        xsrfToken = xsrfToken.split('=')[1]
    }
    let token = document.cookie.split('; ').find(row => row.startsWith('token'));
    if (token) {
        token = token.split('=')[1]
    }

    let formData = new FormData();
    formData.append('file', document.getElementById('zip').files[0]);

    fetch(`${process.env.REACT_APP_API_URL}/api/package-cards/zip/${packageInfo.packageId}`, {
      method: 'POST',
      cache: 'no-store',
      headers: {
        'X-XSRF-TOKEN': decodeURIComponent(xsrfToken),
        'Bearer': decodeURIComponent(token)
      },
      credentials: 'include',
      body: formData
    })
    .then(response => response.json())
    .then(data => {
      if(!data.errors) {
        setCardNumber(data.package_cards.filter((card) => card.rank != 9).map((card) => card.number).reduce((a, b) => a + b, 0));
        setTotalRefundPoint(data.package_cards.map((card) => card.rank == 9 ? card.point : card.number * card.point).reduce((a, b) => a + b, 0));
        setCardList(data.package_cards.map((card) => {
          return {
            url: process.env.REACT_APP_ASSET_URL + card.image_url,
            name: card.name,
            rank: card.rank,
            number: card.number,
            stock: card.stock,
            rewardPoint: card.point,
            id: card.id,
            card_id: card.card_id,
            psa: card.psa,
            isPsaEnabled: card.is_psa_enabled == 1 ? "1" : "2",
          }
        }))
      } else {
        // ファイルのクリア
        document.getElementById('zip').value = '';
        alert(data.errors);
      }
      setZipUpButton(t('new_oripa_select_card.zip'));
    })
    .catch((error) => {
      document.getElementById('zip').value = '';
      console.error('Error:', error);
      alert(t('common.error'));
      setZipUpButton(t('new_oripa_select_card.zip'));
    });

  }

  const openModal = () => {
    setModalIsOpen(true);
  }

  const closeModal = () => {
    setModalIsOpen(false);
  }

  const openImageModal = (e) => {
    e.preventDefault();
    
    setModalImageIsOpen([true, e.target.src]);
  }

  const closeImageModal = () => {
    setModalImageIsOpen([false, '']);
  }

  const CreateCardList = () => {
    return cardList.map((card) => {
      return <Tr oripa={card} openModal={openModal} openImageModal={openImageModal} cardNumber={cardNumber} setCurrentCard={setCurrentCard} cardList={cardList}  setCardList={setCardList} key={'card'+card.id} />
    })
  }

  const [currentCard, setCurrentCard] = useState({
    url: '',
    name: '',
    rank: "1",
    number: 1,
    rewardPoint: 0,
    id: '',
    option: "1",
    image: '',
    psa: 0,
    isPsaEnabled: "2",
  });

  const [selectedOption, setSelectedOption] = useState('1');
  
  const [totalRefundPoint, setTotalRefundPoint] = useState(0);

  useEffect(() => {
    let xsrfToken = document.cookie.split('; ').find(row => row.startsWith(process.env.REACT_APP_XSRF_TOKEN));
    if (xsrfToken) {
        xsrfToken = xsrfToken.split('=')[1]
    }
    let token = document.cookie.split('; ').find(row => row.startsWith('token'));
    if (token) {
        token = token.split('=')[1]
    }

    fetch(`${process.env.REACT_APP_API_URL}/api/package-cards/${packageInfo.packageId}`, {
      headers: {
        'X-XSRF-TOKEN': decodeURIComponent(xsrfToken),
        'Bearer': decodeURIComponent(token)
      },
      credentials: 'include',
    })
    .then(response => response.json())
    .then(data => {
      if(!data.errors) {
        if (data.package_cards) {
          setCardNumber(data.package_cards.filter((card) => card.rank != 9).map((card) => card.number).reduce((a, b) => a + b, 0));
          setTotalRefundPoint(data.package_cards.map((card) => card.rank == 9 ? card.point : card.number * card.point).reduce((a, b) => a + b, 0));
          setCardList(data.package_cards.map((card) => {
            return {
              url: process.env.REACT_APP_ASSET_URL + card.image_url,
              name: card.name,
              rank: card.rank,
              number: card.number,
              stock: card.stock,
              rewardPoint: card.point,
              id: card.id,
              card_id: card.card_id,
              psa: card.psa,
              isPsaEnabled: card.is_psa_enabled,
            }
          }))
        }
      }
    })
  }, [])

  let {id} = useParams();

  return (
    <>
      <Header />
      <SideMenu />
      <NewCardSettingModal 
        modalIsOpen={modalIsOpen}
        closeModal={closeModal}
        currentCard={currentCard}
        setCurrentCard={setCurrentCard}
        selectedOption={selectedOption}
        setSelectedOption={setSelectedOption}
        packageInfo={packageInfo}
        cardList={cardList}
        setCardList={setCardList}
        cardNumber={cardNumber}
        setCardNumber={setCardNumber}
        setTotalRefundPoint={setTotalRefundPoint}
      />
      <div className="oripa">
        <div className="oripa-content">
          {!id ?
            <div className="oripa-title">{t('new_oripa_select_card.oripa')}</div>
            :
            <div className="oripa-title">{t('new_oripa_select_card.stock')}</div>
          }
          <div className='clearfix'></div>
          <ul className="progressbar">
            <li className="active"></li>
            <li className="active">{t('new_oripa_select_card.card_setting')}</li>
            <li></li>
          </ul>
          <div className='clearfix'></div>
          <dl className="oripa-info-confirm oripa-info-confirm-half">
            <dt className="oripa-info-confirm-title">{t('new_oripa_select_card.oripa_name')}</dt>
            <dd className="oripa-info-confirm-text">{packageInfo.packageName}</dd>
            <dt className="oripa-info-confirm-title">{t('new_oripa_select_card.total_card')}</dt>
            <dd className="oripa-info-confirm-text">{packageInfo.packageNumber.toLocaleString()}{t('new_oripa_select_card.card')}</dd>
            <dt className="oripa-info-confirm-title">{t('new_oripa_select_card.setted_card')}</dt>
            <dd className="oripa-info-confirm-text">{cardNumber.toLocaleString()}{t('new_oripa_select_card.card')}</dd>
            <dt className="oripa-info-confirm-title">{t('new_oripa_select_card.total_points')}</dt>
            <dd className="oripa-info-confirm-text">{totalRefundPoint.toLocaleString()}pt</dd>
          </dl>
          <div className='clearfix'></div>
          <div className="oripa-info-confirm-button">
            <button className="oripa-info-confirm-button-new" onClick={addCardHandler}>{t('new_oripa_select_card.new')}</button>
            <button className="oripa-info-confirm-button-csv" onClick={csvCardHandler}>{zipUpButton}</button>
            <button className="oripa-info-confirm-button-csv" onClick={templateHandler}>{t('new_oripa_select_card.csv')}</button>
            <button className="oripa-info-confirm-button-confirm" onClick={moveNewOripaConfirm}>{t('new_oripa_select_card.next_confirm')}</button>
          </div>
          <input type="file" id="zip" accept=".zip" style={{display: 'none'}} onChange={zipCardHandler}/>

          <div className="oripa-content-table">
            <table className="oripa-content-table">
              <thead>
                <tr>
                  <th>{t('new_oripa_select_card.image')}</th>
                  <th>{t('new_oripa_select_card.name')}</th>
                  <th>{t('new_oripa_select_card.rank')}</th>
                  <th>{t('new_oripa_select_card.cards')}</th>
                  <th>{t('new_oripa_select_card.points')}</th>
                  <th>PSA</th>
                  <th>{t('new_oripa_select_card.probability')}</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <CreateCardList />
              </tbody>
            </table>
          </div>

          <div className="oripa-info-button">
            <button className="oripa-info-button-back" onClick={moveNewOripaGeneral}>{t('new_oripa_select_card.back')}</button>
            <button className="oripa-info-button-next" onClick={moveNewOripaConfirm}>{t('new_oripa_select_card.next')}</button>
          </div>
        </div>
      </div>
      {modalImageIsOpen[0] && 
        <ImageModal
          modalIsOpen={modalImageIsOpen}
          closeModal={closeImageModal}
          link={modalImageIsOpen[1]}
          customClass='oripa-info-card-image-modal'
        />
      }
    </>
  )
}

export default NewOripaSelectCard